// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + "developerStaticHighlighter" + ".90a4212c8.chunk.js"
}